const root = () => window.Shopify?.routes?.root || '/';
const sectionIds = () => [...document.querySelectorAll('[data-cart-section]')].map((el) => el.dataset.cartSection);

function swap(sections, freshKey) {
  for (const [id, html] of Object.entries(sections || {})) {
    const current = document.querySelector(`[data-cart-section="${id}"]`);
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector(`[data-cart-section="${id}"]`);
    if (!current || !next) continue;
    current.innerHTML = next.innerHTML;
    if (freshKey) current.querySelector(`[data-key="${CSS.escape(freshKey)}"]`)?.classList.add('is-fresh');
  }
  document.dispatchEvent(new CustomEvent('cart:rendered'));
}

async function refresh() {
  const ids = sectionIds();
  if (!ids.length) return;
  const res = await fetch(`${root()}?sections=${ids.join(',')}`);
  if (res.ok) swap(await res.json());
}

async function change(line, quantity) {
  const key = line.dataset.key;
  line.classList.add(quantity === 0 ? 'is-leaving' : 'is-busy');
  if (quantity === 0) await new Promise((r) => setTimeout(r, 320));
  try {
    const res = await fetch(`${root()}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity, sections: sectionIds(), sections_url: location.pathname }),
    });
    const cart = await res.json();
    if (!res.ok) throw new Error(cart.description || cart.message);
    swap(cart.sections, quantity > 0 ? key : null);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: cart.item_count, source: 'panel' } }));
  } catch (err) {
    line.classList.remove('is-busy', 'is-leaving');
    console.warn('Cart update failed', err);
  }
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-cart-section] [data-qty]');
  if (!btn) return;
  e.preventDefault();
  const line = btn.closest('[data-key]');
  if (line) change(line, Math.max(0, +btn.dataset.qty));
});

function offers() {
  try { return JSON.parse(document.getElementById('DcOffers').textContent); } catch { return null; }
}

function fill(template, data) {
  return template.replace(/COUNT|SAVE|LABEL/g, (k) => data[k.toLowerCase()] ?? '');
}

function pop(count) {
  const o = offers();
  if (!o || !o.l1) return;
  let text, win = false;
  if (count < o.q1) text = fill(o.add, { count: o.q1 - count, save: o.s1 });
  else if (count === o.q1) { win = true; text = '🔓 ' + fill(o.unlocked, { label: o.l1 }); }
  else if (o.l2 && count < o.q2) text = fill(o.next, { count: o.q2 - count, save: o.s2 });
  else if (o.l2 && count === o.q2) { win = true; text = '🔓 ' + fill(o.unlocked, { label: o.l2 }); }
  else return;

  document.querySelector('.pop')?.remove();
  const el = document.createElement('div');
  el.className = 'pop';
  el.setAttribute('role', 'status');
  el.innerHTML = `<div class="pop__card${win ? ' is-win' : ''}"></div>`;
  el.firstChild.textContent = text;
  if (win && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    for (let i = 0; i < 14; i++) {
      const dot = document.createElement('span');
      const a = (i / 14) * Math.PI * 2;
      dot.className = 'pop__burst';
      dot.style.cssText = `--x:${Math.cos(a) * (60 + Math.random() * 50)}px;--y:${Math.sin(a) * (40 + Math.random() * 40)}px`;
      el.append(dot);
    }
  }
  document.body.append(el);
  setTimeout(() => el.remove(), 3400);
}

document.addEventListener('cart:updated', (e) => {
  if (e.detail?.source === 'panel') return;
  refresh();
  pop(e.detail?.count ?? 0);
});

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-copy]');
  if (!btn) return;
  try {
    await navigator.clipboard.writeText(btn.dataset.copy);
    const o = offers();
    const old = btn.innerHTML;
    btn.textContent = o?.copied || 'Copied';
    setTimeout(() => { btn.innerHTML = old; }, 1400);
  } catch {}
});
